import React, { useState, useEffect } from 'react';
import { HelpCircle, X } from 'lucide-react';
import axios from 'axios';

const Tooltip = ({ tooltipKey, size = 16, className = "text-gray-400" }) => {
  const [showModal, setShowModal] = useState(false);
  const [tooltipData, setTooltipData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTooltip = async () => {
    if (tooltipData) {
      // Déjà chargé
      setShowModal(true);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await axios.get(`${backendUrl}/api/tooltips/${tooltipKey}`);
      setTooltipData(response.data);
      setShowModal(true);
    } catch (err) {
      console.error('Erreur lors du chargement du tooltip:', err);
      setError('Impossible de charger l\'aide');
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    fetchTooltip();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {/* Icône cliquable */}
      <button
        type="button"
        onClick={handleClick}
        className="inline-flex items-center justify-center hover:text-celadon transition-colors cursor-help"
        title="Cliquez pour plus d'informations"
      >
        <HelpCircle size={size} className={className} />
      </button>

      {/* Modal de tooltip */}
      {showModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
          }}
        >
          <div 
            className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Bouton fermer */}
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
              }}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X size={20} />
            </button>

            {/* Contenu */}
            {loading && (
              <div className="text-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-celadon mx-auto"></div>
                <p className="mt-2 text-gray-600">Chargement...</p>
              </div>
            )}

            {error && (
              <div className="text-center py-8">
                <p className="text-red-600">{error}</p>
              </div>
            )}

            {tooltipData && (
              <>
                <h3 className="text-xl font-bold text-gray-900 mb-4 pr-8">
                  {tooltipData.title}
                </h3>
                <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {tooltipData.help_text}
                </div>
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    closeModal();
                  }}
                  className="mt-6 w-full bg-celadon text-white py-2 px-4 rounded-lg hover:bg-celadon-light transition-colors"
                >
                  Compris
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Tooltip;
